import { useState } from 'react';
import PropTypes from 'prop-types';
import { styles } from './index.style';
import _ from '../../utils/LodashImports';

export function WhatsappWidget({ appCtx, href }) {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!open);

  const textDictionary = _.get(appCtx, 'siteConfig.textDictionary', {});

  const {
    WHATSAPP_WIDGET_TITLE = 'Whatsapp',
    WHATSAPP_WIDGET_SUB_TITLE = 'Hola, ¿cómo podemos apoyarte?',
    WHATSAPP_WIDGET_MESSAGE = 'Venta de productos y servicios, seguimiento a tu pedido, horarios, ubicaciones y más...',
  } = textDictionary;

  return (
    <div className="container">
      <style jsx>{styles}</style>
      {open && (
        <div className="screen">
          <div className="chat-box">
            <div className="controllers">
              <div className="bar" />
              <button className="close-button" onClick={toggleOpen} type="button" />
            </div>
            <div className="header">
              <div className="logo" />
              <div>
                <div className="title">{WHATSAPP_WIDGET_TITLE}</div>
                <div className="subtitle">{WHATSAPP_WIDGET_SUB_TITLE}</div>
              </div>
            </div>

            <a href={href} className="message" rel="noopener noreferrer" target="_blank">
              {WHATSAPP_WIDGET_MESSAGE}
            </a>

            <div className="arrow" />
          </div>
        </div>
      )}

      <button className="button" onClick={toggleOpen} type="button" />
    </div>
  );
}

WhatsappWidget.propTypes = {
  href: PropTypes.string.isRequired,
  appCtx: PropTypes.object.isRequired,
};
